export default __webpack_public_path__ + "static/media/check.0f99fe66.svg";